import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import { InputGlobal } from "../InputGlobal";
import { validateName, simplyClick } from "../../helpers/index";
import { EventsErrorName } from "../../constants/index";
import "./Name.scss";
import cn from "classnames";

export const Name = ({ data, setData, nextStep }) => {
  const [errorName, setErrorName] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    const { status, error } = validateName(data.first_name);

    if (!status) {
      setErrorName(error);

      const eventKey = EventsErrorName[error.text];
      if (eventKey) {
        simplyClick(eventKey);
      }
      return;
    }
    simplyClick("cl_lnd_st3_continue");
    nextStep();
  };

  const handleAddName = (e) => {
    setErrorName(null);
    setData({ ...data, first_name: e.target.value });
  };

  return (
    <form className="form__name" onSubmit={handleSubmit}>
      <h1 className="global__title global__title-mobile">What is your name?</h1>

      <InputGlobal
        name="name"
        className={cn("input__global", { error: errorName })}
        onChange={handleAddName}
        placeholder="Enter your name"
        onFocus={() => simplyClick("cl_lnd_st3_type_name")}
        value={data.first_name || ""}
      />

      {errorName && <p className="error-text">{errorName.text || errorName}</p>}

      <ButtonSubmit text="Continue" />

      <div className="slider__box">
        <span className="step active"></span>
        <span className="step active"></span>
        <span className="step active"></span>
        <span className="step"></span>
        <span className="step"></span>
      </div>
    </form>
  );
};
